import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="accordion"
// 汎用アコーディオン: ボタンクリックでコンテンツ領域を開閉
export default class extends Controller {
  static targets = ["content", "trigger", "icon", "text"]
  static classes = ["open", "triggerOpen", "iconOpen"]
  static values = { openText: String, closeText: String }

  toggle() {
    const isOpen = this.contentTarget.classList.toggle(this.openClass)

    if (this.hasTriggerTarget && this.hasTriggerOpenClass) {
      this.triggerTarget.classList.toggle(this.triggerOpenClass, isOpen)
    }

    if (this.hasIconTarget && this.hasIconOpenClass) {
      this.iconTarget.classList.toggle(this.iconOpenClass, isOpen)
    }

    if (this.hasTextTarget) {
      this.textTarget.textContent = isOpen ? this.closeTextValue : this.openTextValue
    }
  }

  // 閉じていれば開く(既に開いていれば何もしない)。
  // 例: 閉じたコンテンツ内の入力欄が送信時の検証(required等)で弾かれたとき、invalidイベントで開いて
  //     ブラウザがその入力欄にフォーカスしてエラーを表示できるようにする
  open() {
    if (this.contentTarget.classList.contains(this.openClass)) return

    this.toggle()
  }
}
